import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import SearchCard from '../../components/SearchCard';
import api from '../../services/api';

interface MemberDetails {
  photo: string;
  fullName: string;
  permanentEnrollmentNumber: string;
  memberType: string;
  rank: string;
  designation: string;
  branch: string;
  memberStatus: string;
  languagesKnown: string;
  dateOfBirth: string;
  currentCity: string;
  currentDistrict: string;
  currentState: string;
  currentPinCode: string;
  bloodGroup: string;
  validUntil: string;
}

const MemberVerification: React.FC = () => {
  const { enrollmentNumber = '' } = useParams<{ enrollmentNumber: string }>();
  const [member, setMember] = useState<MemberDetails | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await api.getPublicMember(enrollmentNumber);
        const data = response.member;
        if (!active || !data) return;
        setMember({
          photo: data.photo || '',
          fullName: data.full_name || '',
          permanentEnrollmentNumber: data.enrollment_number || '',
          memberType: data.member_type || '',
          rank: data.rank || '',
          designation: data.designation || '',
          branch: data.branch || '',
          memberStatus: data.member_status || '',
          languagesKnown: data.languages_known || '',
          dateOfBirth: data.date_of_birth || '',
          currentCity: data.current_city_village || '',
          currentDistrict: data.current_district || '',
          currentState: data.current_state || '',
          currentPinCode: data.current_pin_code || '',
          bloodGroup: data.blood_group || '',
          validUntil: data.valid_until || '',
        });
      } catch (err: any) {
        if (active) setError(err?.message || 'Active member not found.');
      } finally {
        if (active) setLoading(false);
      }
    };
    if (enrollmentNumber) load();
    else {
      setError('Invalid member link.');
      setLoading(false);
    }
    return () => { active = false; };
  }, [enrollmentNumber]);

  return (
      <main className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black">
        <PageTitle title="Member Verification" subtitle="CCRO Verified Member Details" compact />
        <div className="mx-auto max-w-5xl px-4 py-4 sm:px-6 lg:px-8">
          {loading && (
            <div className="flex justify-center py-16">
              <div className="h-12 w-12 animate-spin rounded-full border-4 border-blue-500/30 border-t-blue-500" />
            </div>
          )}
          {!loading && error && (
            <div className="rounded-xl bg-red-500/10 px-6 py-8 text-center text-red-400">{error}</div>
          )}
          {!loading && member && <SearchCard member={member} verificationLayout />}
        </div>
      </main>
  );
};

export default MemberVerification;
